<template>
    <div class="v-сheck-buttons">
        <div class="v-сheck-button" v-for="button in buttons" :key="button.id">
            <div class="сheck-button-icon" @click="toggleActive(button)">
                <transition name="fade-scale">
                    <div class="active-icon" v-if="button.isActive"></div>
                </transition>
            </div>
            <p @click="toggleActive(button)">{{ button.text }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'VСheckButton',

    props: {
        buttons: {
            type: Array,
            required: true,
        }
    },

    methods: {
        toggleActive(button) {
            button.isActive = !button.isActive;
        }
    }
}
</script>

<style lang="scss">
.v-сheck-buttons {
    display: flex;
    flex-direction: column;
    gap: 5px;

    .v-сheck-button {
        display: flex;
        align-items: start;
        gap: 10px;

        p {
            cursor: pointer;
            user-select: none;
        }

        .сheck-button-icon {
            width: 20px;
            height: 20px;
            min-width: 20px;
            flex-shrink: 0;
            border-radius: 5px;
            background-color: var(--color-bg-light);
            display: flex;
            align-items: center;
            justify-content: center;
            //box-shadow: 0 0 4px var(--color-bg-light);

            cursor: pointer;

            .active-icon {
                width: 10px;
                height: 10px;
                border-radius: 3px;
                background-color: var(--color-blue);
                box-shadow: 0 0 5px 2px color-mix(in srgb, var(--color-blue) 50%, transparent);
            }
        }
    }
}

.fade-scale-enter-active,
.fade-scale-leave-active {
    transition: all 0.2s ease;
}

.fade-scale-enter-from,
.fade-scale-leave-to {
    opacity: 0;
    transform: scale(0.2);
}
</style>
